


<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 315 315" width="100%" height="100%" style="enable-background:new 0 0 350 350;" xml:space="preserve">
<g transform="translate(-5 5) ">
	<g opacity="0.15">
		
			<image style="overflow:visible;" width="350" height="90" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAV8AAABbCAYAAADUU4YjAAAACXBIWXMAAAsSAAALEgHS3X78AAAA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" transform="matrix(1 0 0 1 0 231.1855)">
		</image>
	</g>
	<g>
		<g>
			<rect x="100.79" y="19.86" fill="#3B4E9A" width="182.8" height="256.71"/>
			<g>
				<rect x="107.21" y="26.97" fill="#93A4D4" width="169.95" height="244.84"/>
				<g>
					<rect x="124.72" y="57.01" fill="#3B4E9A" width="138.75" height="7.94"/>
					<rect x="124.72" y="105.45" fill="#3B4E9A" width="138.75" height="3.64"/>
					<rect x="124.72" y="114.01" fill="#3B4E9A" width="138.75" height="3.64"/>
					<rect x="124.72" y="122.57" fill="#3B4E9A" width="138.75" height="3.64"/>
					<rect x="124.72" y="131.14" fill="#3B4E9A" width="138.75" height="3.64"/>
					<rect x="124.72" y="139.7" fill="#3B4E9A" width="138.75" height="3.64"/>
					<rect x="124.72" y="148.27" fill="#3B4E9A" width="138.75" height="3.64"/>
					<g>
						<circle fill="#3B4E9A" cx="154.64" cy="198.01" r="10.71"/>
						<path fill="#3B4E9A" d="M210.17,208.3c-0.03,0-0.06,0-0.09-0.01c-0.29-0.05-0.49-0.33-0.44-0.62c0.1-0.59,2.54-14.44,10.22-19.15
							c0.55-0.33,0.89-0.16,1.05-0.03c0.67,0.58,0.16,2.05-2.15,7.59c-0.92,2.21-2.01,4.83-2.46,6.42c0.82-1.07,2.04-2.91,3.02-4.37
							c3.04-4.56,3.63-5.31,4.22-5.31c0.22,0,0.42,0.1,0.54,0.28c0.32,0.46,0.08,1.24-0.76,3.51c-0.32,0.87-0.81,2.21-0.96,2.92
							c0.44-0.39,1.08-1.23,1.46-1.73c1.05-1.37,1.59-2.02,2.21-1.93c0.13,0.02,0.45,0.11,0.61,0.54c0.06,0.18,0.09,0.37,0.12,0.59
							c0.08,0.55,0.18,1.17,0.84,1.54c1.33,0.75,5.18,0.71,15.91-3.77c0.27-0.11,0.59,0.02,0.7,0.29c0.11,0.27-0.02,0.59-0.29,0.7
							c-9.06,3.78-14.58,4.99-16.85,3.71c-1.11-0.62-1.27-1.67-1.37-2.3c-0.31,0.32-0.73,0.87-1.04,1.28
							c-1.16,1.51-1.93,2.42-2.7,2.36c-0.24-0.02-0.44-0.14-0.57-0.34c-0.37-0.59-0.01-1.74,0.91-4.23c0.15-0.4,0.32-0.86,0.46-1.28
							c-0.74,1.02-1.75,2.53-2.57,3.76c-3.4,5.11-4.02,5.85-4.7,5.66c-0.11-0.03-0.45-0.16-0.48-0.66c-0.07-1.2,1.05-3.97,2.75-8.07
							c0.87-2.08,2-4.81,2.28-6.01c-6.99,4.69-9.33,18.05-9.35,18.18C210.65,208.12,210.42,208.3,210.17,208.3z M222.02,199.77
							L222.02,199.77L222.02,199.77z"/>
					</g>
				</g>
			</g>
			<path fill="#FAD333" d="M232.23,15.7h-21.55c0.48-1.28,0.75-2.66,0.75-4.1c0-6.41-5.19-11.6-11.6-11.6c-6.41,0-11.6,5.19-11.6,11.6
				c0,1.45,0.27,2.83,0.75,4.1h-21.55c-1.73,0-3.14,1.41-3.14,3.14v8.71c0,1.73,1.41,3.14,3.14,3.14h64.81
				c1.73,0,3.14-1.41,3.14-3.14v-8.71C235.37,17.11,233.97,15.7,232.23,15.7z M199.83,15.88c-2.37,0-4.28-1.92-4.28-4.28
				c0-2.37,1.92-4.28,4.28-4.28c2.36,0,4.28,1.92,4.28,4.28C204.11,13.96,202.19,15.88,199.83,15.88z"/>
			<path fill="#F9B925" d="M167.43,30.69h64.81c1.73,0,3.14-1.41,3.14-3.14v-8.71L167.43,30.69z"/>
		</g>
		<g>
			<path fill="#E49863" d="M169.96,95.37c-1.24,2.51-3.24,5.36-5.08,5.93c-2.09,0.64-3.05,1.76-3.05,1.76l-1.52-1.11l-1.81-1.32
				c0,0,0.07-0.21,0.2-0.55c0.13-0.34,0.32-0.81,0.58-1.32c0,0,0.67-0.7,0.41-1.69c-0.26-0.99-0.04-2.46,0.68-3.3
				c0.71-0.83,1.54-2.99,1.91-2.88c0.89,0.25-0.78,3.15-0.45,3.76c0.3,0.55,0.75,0.42,0.84,0.39c0.01,0,0.01,0,0.02-0.01
				c2.65-0.85,6.34-6.53,7.62-5.58C170.76,89.8,170.49,94.3,169.96,95.37z"/>
			<path fill="#284663" d="M118.4,89.12c0,0,12.35,18.91,17.9,24.47l22.52-14.73c0,0,3.07,1.15,4.24,4.37c0,0-14.71,25.84-27.66,26.18
				c-12.95,0.34-28.99-33.84-28.99-33.84L118.4,89.12z"/>
			<g>
				<path fill="#1D1D1B" d="M74.25,276.57h-9.37c-1.18-0.64-2.23-2.11-2.56-4.29c-0.46-3.02-3.84-4.67-4.57-7.14
					c-0.73-2.47,3.02-5.94,3.02-5.94l0.63-0.81l0.65-0.84l6.22,1.46c0,0,0.15,1.48,0.25,3.37c0.07,1.36,0.1,2.93,0.03,4.31
					c-0.18,3.29,0.92,6.84,3.85,7.48C74.54,274.65,74.44,275.93,74.25,276.57z"/>
				<path fill="#1D1D1B" d="M128.64,276.57H107.2c-1.03-1.26-0.65-5.9-0.49-7.42c0.03-0.31,0.05-0.48,0.05-0.48s7.32-5.85,8.32-1.37
					c0.03,0.14,0.07,0.28,0.11,0.41c1.27,4.19,6.95,6.1,10.23,6.63C127.56,274.69,128.35,275.8,128.64,276.57z"/>
				<path fill="#63B347" d="M124.55,156.93c0,0-1.11,13.87-2.42,30.53c-1.78,22.64-3.91,50.45-4.12,55.72
					c-0.37,9.15-1.83,23.78-1.83,23.78s-3.47,3.48-10.43,2.01c0,0-6.2-20.89-7.97-42.99c-0.03-0.36-0.05-0.73-0.08-1.09
					c-1.65-22.5-4.21-69.88-4.21-69.88L124.55,156.93z"/>
				<path opacity="0.5" fill="#3E954E" d="M124.55,156.93c0,0-1.11,13.87-2.42,30.53l-24.35,38.52c-0.03-0.36-0.05-0.73-0.08-1.09
					c-1.65-22.5-4.21-69.88-4.21-69.88L124.55,156.93z"/>
				<path fill="#63B347" d="M119.48,158.58c0,0-20.03,50.22-33.2,73.82c-13.17,23.6-17.29,30.19-17.29,30.19s-7.55-3.02-8.23-5.08
					c0,0,5.04-45.56,13.86-56.67c4.98-6.28,10.84-25.11,11.11-31.69c0.27-6.59,1.78-19.62,1.78-19.62L119.48,158.58z"/>
			</g>
			<path fill="#E49863" d="M114.49,85.37c-7.83,2.47-21.37-4.2-21.37-4.2s7.22-5.42,6.84-16.68l6.05,4.88l4.11,3.31
				c0,0-0.02,1.95-0.47,5.38c-0.12,0.9-0.27,1.9-0.45,3C112.56,82.91,114.49,85.37,114.49,85.37z"/>
			<path fill="#D89060" d="M110.12,72.68c0,0-0.02,1.95-0.47,5.38c-4.56-0.78-9.72-8.14-9.72-8.14c2.32-0.67,4.35-0.79,6.08-0.54
				L110.12,72.68z"/>
			<path fill="#E49863" d="M112.52,72.5c0,0-12.93,2.15-14.14-5.92c-1.21-8.07-3.7-13.23,4.5-14.95c8.2-1.71,10.28,1.13,11.34,3.72
				C115.27,57.95,115.85,71.73,112.52,72.5z"/>
			<path fill="#3B4E9A" d="M125.42,158.08c-0.24,0.2-0.51,0.31-0.82,0.31c-2.94-0.04-11.51,1.59-18.76,0.85
				c-6.11-0.59-11.53-2.4-17.34-5c-0.77-0.35-2.55-1.29-2.51-2.16c0.03-0.94,0.12-2.31,0.24-4.04c0.41-6,1.13-16.32,0.43-28.22
				c-0.13-2.22-0.19-4.42-0.2-6.58c-0.06-16.13,3.14-30.32,9.57-35.13c0.55-0.39,3.92,1.25,7.02,2.78c2.86,1.41,5.72,1.57,8.43,1.02
				l2.7,2.39c3.29,3.06,6.9,7.21,8.47,13.52c1.33,5.37,2.12,15.05,2.55,25.09c0.2,4.55,0.35,9.13,0.39,13.49v0.16
				c0.04,0.43,0.04,0.9,0.04,1.33C125.77,149.07,125.61,157.93,125.42,158.08z"/>
			<path fill="#233862" d="M86.22,148.04c0.41-6,1.13-16.32,0.43-28.22c-0.13-2.22-0.19-4.42-0.2-6.58c2.68-6.5,4.87-11.21,4.87-11.21
				h6.75C98.07,102.04,103.02,135.84,86.22,148.04z"/>
			<path fill="#3C3C3B" d="M98.36,65.8c0,0,1.33-0.22,1.11-2.05c-0.21-1.83-0.21-4.22,1.27-3.77c1.49,0.44,1.56,1.63,2.17,0.94
				c0.61-0.69,0.62-3.62,5.04-3.83c4.42-0.2,6.22,1.34,8.27,0.43c2.06-0.9,2.16-4.02,2.16-4.02s-0.58,1.11-1.47,1.46
				c0,0,3.43-4.69-0.54-7.91c-3.97-3.22-8.02-1.11-10.32-0.97c-5.06,0.31-8.33,0.61-9.99,3.94C94.43,53.35,95.11,62.59,98.36,65.8z"
				/>
			<g>
				<path fill="#233862" d="M225.06,50.43l-12.15,7.51l-1.36-2.2l12.15-7.51c0.61-0.38,1.41-0.19,1.78,0.42l0,0
					C225.86,49.26,225.67,50.06,225.06,50.43z"/>
				<path fill="#3E954E" d="M94.96,119.19l3.26,7.86l-0.06,0.04l0.16,0.18l0.09,0.22l0.06-0.04l5.57,6.43
					c0,0,83.48-51.57,114.84-78.05c1-0.85,1.23-2.31,0.54-3.42l0,0c-0.69-1.12-2.1-1.57-3.3-1.05
					C178.41,67.57,94.96,119.19,94.96,119.19z"/>
				<path fill="#2A6332" d="M217.61,51.18c-0.14,0.48-0.42,0.92-0.82,1.26c-31.36,26.48-114.84,78.05-114.84,78.05l-4.41-5.08
					l0.68,1.64l-0.06,0.04l0.16,0.18l0.09,0.22l0.06-0.04l5.57,6.43c0,0,83.48-51.57,114.84-78.05c1-0.85,1.23-2.31,0.54-3.42
					C219.01,51.73,218.34,51.3,217.61,51.18z"/>
				<path fill="#284663" d="M16.94,182.09l14.45-8.93l-4.05-6.55l-14.45,8.93c-1.81,1.12-2.37,3.49-1.25,5.3l0,0
					C12.76,182.65,15.13,183.21,16.94,182.09z"/>
				<path fill="#3E954E" d="M106.35,134.59l-65.62,40.56c-4.92,3.04-11.36,1.52-14.4-3.4l0,0c-3.04-4.92-1.52-11.36,3.4-14.4
					l65.62-40.56c0.85-0.52,1.96-0.26,2.48,0.59l9.11,14.74C107.46,132.96,107.2,134.07,106.35,134.59z"/>
				<path fill="#2A6332" d="M25.45,169.97c0.23,0.61,0.53,1.21,0.88,1.79l0,0c3.04,4.92,9.49,6.44,14.4,3.4l65.62-40.56
					c0.85-0.52,1.11-1.63,0.59-2.48l-1.15-1.85l-67.15,41.51C34.31,174.45,28.78,173.58,25.45,169.97z"/>
				<path fill="#F1A34F" d="M86.21,119.98l-6.49,4.12c-0.65,2.25-2.48,4.61-5.16,6.31c-2.67,1.7-5.58,2.36-7.9,2l-38.75,24.65
					c-5.4,3.44-7,10.63-3.57,16.03l3.71,5.83c0.59,0.93,0.32,2.16-0.61,2.75c-0.93,0.59-2.16,0.32-2.75-0.61l-3.71-5.83
					c-4.61-7.26-2.47-16.91,4.79-21.53l58.29-37.07c0.93-0.59,2.16-0.32,2.75,0.61C87.41,118.16,87.13,119.39,86.21,119.98z"/>
				<polygon fill="#2A6332" points="105.93,133.09 105.79,130.26 97.85,117.41 109.02,129.94 				"/>
			</g>
			<path fill="#E49863" d="M73.13,152.5c0.01-0.15,0.02-0.31,0.03-0.47c0.06-0.8,1.57-2.82,1.57-2.82l-3.79-1.97l-1.5,2.48
				c-2.27,1.8-2.31,1.84-1.89,5.29c0.36,2.99-1.6,3.03-1.55,5.17c0.05,2.14,2.8,1.09,2.8,1.09c4.27-2,4.62-3.01,4.49-5.05
				c0.4,0.57,0.86,0.91,1.24,0.66c0.34-0.22-0.34-1.1-0.63-3.12C73.85,153.45,73.49,152.94,73.13,152.5z"/>
			<path fill="#3B4E9A" d="M70.89,150.75c2.43,0.47,5.07,0.28,5.07,0.28s7.22-22.29,8.14-24.33c0.93-2.04,21.43-26.14,21.43-26.14
				l-8.54-21.38c0,0-22.18,37.05-24.43,42.25c-3.72,8.6-5.01,27.89-5.01,27.89S68.98,150.38,70.89,150.75z"/>
			<path fill="#E49863" d="M170.5,92.16c0,0,0.2-3.29-1.09-3.29c-1.29,0-7.89,8.52-7.89,8.52l0.53,1.83L170.5,92.16z"/>
		</g>
	</g>
</g>
</svg>